import { NewContractSchema } from '@vy/types';
import { oz } from '@vy/utils';
import { PlanAssignmentCustomerDataSchema } from './plan-assignment-customer-data-schema';

export const NewPlanAssignmentSchema = oz.object({
  contract: NewContractSchema,
  selectedCustomers: oz.array(PlanAssignmentCustomerDataSchema),
});

export type NewPlanAssignment = oz.infer<typeof NewPlanAssignmentSchema>;
